import trucateFilename from 'data/services/string/trucateFilename';
import {
    StyledContent,
    StyledContainer,
    StyledFileName,
    StyledIcon,
    StyledIconContainer,
    StyledInfo,
} from './styled';

interface GenericProps {
    filename?: string | null;
}

const Generic = ({ filename }: GenericProps) => (
    <StyledContainer>
        <StyledIconContainer>
            <StyledIcon />
        </StyledIconContainer>
        <StyledContent>
            <StyledFileName>{trucateFilename(filename || '', 30)}</StyledFileName>
            <StyledInfo>Download file.</StyledInfo>
        </StyledContent>
    </StyledContainer>
);

export default Generic;
